enum ThemeModes {
  dark = 'dark-mode',
  light = 'light-mode',
}

export default ThemeModes
